export const SCHEDULE_HOME = {
    categories: 'categories'
}
